var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.sections),function(section){return _c('div',{key:section.id,staticClass:"BgEmotionChartLabels-container"},[_c('div',{staticClass:"BgEmotionChartLabels--large",style:({ left: _vm.getLeft(section.timestamp_start) })}),_c('div',{staticClass:"BgEmotionChartLabels--large",style:({ left: _vm.getLeft(section.timestamp_end) })})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }